export default __webpack_public_path__ + "static/media/new-conversation.8fe3317f.wav";